const win = window;
const doc = document;
// prettier-ignore
const Support = (function Support() {
    const testDiv = doc.createElement('div');
    return {
        touch: win.Modernizr && win.Modernizr.touch === true || (function checkTouch() {
            return !!('ontouchstart' in win || win.DocumentTouch && doc instanceof win.DocumentTouch);
        }()),

        pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent),
        prefixedPointerEvents: !!win.navigator.msPointerEnabled,

        transition: (function checkTransition() {
            const style = testDiv.style;
            return 'transition' in style || 'webkitTransition' in style || 'MozTransition' in style;
        }()),
        transforms3d: win.Modernizr && win.Modernizr.csstransforms3d === true || (function checkTransforms3d() {
            const style = testDiv.style;
            return 'webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style;
        }()),

        flexbox: (function checkFlexbox() {
            const style = testDiv.style;
            const styles = 'alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient'.split(' ');
            for (let i = 0; i < styles.length; i += 1) {
                if (styles[i] in style) { return true; }
            }
            return false;
        }()),

        observer: (function checkObserver() {
            return 'MutationObserver' in win || 'WebkitMutationObserver' in win;
        }()),

        passiveListener: (function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get: function get() {
                        supportsPassive = true;
                    }
                });
                win.addEventListener('testPassiveListener', null, opts);
            } catch (e) {
                // No support
            }
            return supportsPassive;
        }()),

        gestures: (function checkGestures() {
            return 'ongesturestart' in win;
        }())
    };
}());

module.exports.support = Support;
module.exports.touchEvents = (function touchEvents() {
    const touch = ['touchstart', 'touchmove', 'touchend'];
    let desktop = ['mousedown', 'mousemove', 'mouseup'];
    if (Support.pointerEvents) {
        desktop = ['pointerdown', 'pointermove', 'pointerup'];
    } else if (Support.prefixedPointerEvents) {
        desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
    }
    const touchEventsTouch = {
        start: touch[0],
        move: touch[1],
        end: touch[2]
    };
    const touchEventsDesktop = {
        start: desktop[0],
        move: desktop[1],
        end: desktop[2]
    };
    return Support.touch ? touchEventsTouch : touchEventsDesktop;
})();

module.exports.device = require('./Device');
